import {
    BusinessRegistrationData,
    DATE_FORMAT,
    getBusinessRegistrationEndpoint,
    RegistrationError,
    RegistrationResult,
} from '@cp-mx/common';
import { WithDefaultCpIntegrationErrors, formatCpDate } from '@cp-shared-19/common-utilities';
import { CpDataApi } from '../../../../../cp-xhr';
import { BusinessFormProps } from '../types';

export const handleSubmit = (
    formValues: BusinessFormProps,
    successCallback: (registrationResult: RegistrationResult, registrationData: BusinessFormProps) => void,
    errorCallback: (
        errorCode: WithDefaultCpIntegrationErrors<RegistrationError>,
        errorMessage: string,
        errorStatus?: number,
    ) => void,
): void => {
    const { businessCustomerNumber, dateFounded } = formValues;
    const registrationData: BusinessRegistrationData = {
        idCustomer: businessCustomerNumber,
        dateFounded: formatCpDate(dateFounded, DATE_FORMAT).toCpDate(),
    };
    CpDataApi.post(getBusinessRegistrationEndpoint(), registrationData)
        .then(response => {
            const responseData: RegistrationResult = response.data;
            successCallback(responseData, formValues);
        })
        .catch(error => {
            const errorStatus: number | undefined = error.response?.status;
            const errorCode = error.response?.data?.code || RegistrationError.NETWORK_ERROR;
            const errorMessage = error.response?.data?.message;
            errorCallback(errorCode, errorMessage, errorStatus);
        });
};
